module.exports = __webpack_public_path__ + "static/media/0-5.eb68f049.svg";